"use strict";
import React from "react";
import PropTypes from "prop-types";
import DocumentIcon from '../components/documentIcon';

const downloadPropertyName = 'stuff';

const initComponent = (utils) => {
    class ExportDownload extends React.Component {
        static dataOrDownload = (props, propName, componentName) => {
            const checkProps = () => {
                return (!props.hasOwnProperty('data') && !props.hasOwnProperty('onDownload')) && new Error(`Either "data" or "onDownload" is required`);
            }
            const checkTypes = () => {
                if ((propName === 'data' && (!Array.isArray(props.data) || !props.data.reduce((isObj, item) => { return isObj && (typeof item === 'object') }, true)) ||
                    (propName === 'onDownload' && typeof props.onDownlaod !== 'function'))) {
                    return new Error(`Invalid prop '${propName} supplied to ${componentName}. Validation failed.`);
                }
                return false;
            }
            return checkProps() && checkTypes();
        }

        static propTypes = {
            label: PropTypes.string,
            saveAs: PropTypes.string,
            data: this.dataOrDownload,
            onDownload: this.dataOrDownload,
            columns: PropTypes.arrayOf(
                PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.shape({ name: PropTypes.string, dataField: PropTypes.string })
                ])),
            disabled: PropTypes.bool,
            textIcon: PropTypes.string
        }

        static defaultProps = {
            textIcon: "csv"
        }

        getData = () => {
            const { data = null, onDownload } = this.props;
            return new Promise((resolve, reject) => {
                const validateArray = (response) => {
                    if (!response.reduce((isObj, item) => { return isObj && typeof item === 'object' }, true)) {
                        reject(`Invalid response. Expected an array of objects.`);
                    } else {
                        resolve(response);
                    }
                }
                const validateData = (response) => {
                    if (Array.isArray(response)) {
                        validateArray(response);
                    } else if (typeof response === 'object') {
                        if (!response.hasOwnProperty(downloadPropertyName) || typeof response[downloadPropertyName] !== 'string') {
                            reject(`Invalid response. Response must implement the iDownloadStuff interface.`);
                        } else {
                            const propName = Object.keys(response).find(p => p.toUpperCase() === response[downloadPropertyName].toUpperCase());
                            if (!propName) {
                                reject(`Invalid response. No matching property found for ${response[downloadPropertyName]}`);
                            }
                            const content = response[propName];
                            if (!Array.isArray(content)) {
                                reject(`Invalid response. Expected an array of objects.`);
                            } else {
                                validateArray(content);
                            }
                        }
                    }
                }
                if (data !== null) {
                    resolve(data);
                } else {
                    let download = onDownload();
                    if (download instanceof Promise) {
                        download
                            .then(result => validateData(result))
                            .catch(error => reject(error));
                    } else {
                        validateData(download);
                    }
                }
            });
        }

        onDownload = () => {
            const { saveAs = "download", columns } = this.props;
            this.getData()
                .then(data => {
                    const content = utils.toCSV(data, columns);
                    var link = document.createElement("a");
                    link.setAttribute("href", content);
                    link.setAttribute("download", saveAs + ".csv");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(error => {
                    throw new Error(error);
                });
        }

        render() {
            const { label, saveAs, data, columns, disabled, textIcon, ...rest } = this.props;

            return (
                <DocumentIcon text={textIcon} title={"Download as " + textIcon.toUpperCase()}  className="export-download" onClick={this.onDownload} disabled={disabled} />
            );
        }
    }

    return ExportDownload;
};

module.exports = initComponent;
